<template>
    <div>
      <!-- 头部start -->
      <crumbs></crumbs>
      <!-- 头部 end-->
          <!-- 广告start -->
      <div class="y-advertisement"><img src="../../static/img/belong.png" alt=""></div>

      <!-- 广告end -->
          <!-- 导航start -->
      <div class="y-navigation">
        <div class="min y-navigation-box">
          <div class="router-active">
          <router-link to="/preview">展项预览 > </router-link> 
          <router-link :to="{path:'/preview',query:{ index:activeIndex,id:coolId}}">
            <span style="color:#0078ff">{{arrList.Name}}</span>
          </router-link> >{{arrList.Title}}</div>
        </div>
      </div>
      <!-- 导航end -->
      <div class="min">
          <h4>{{arrList.Title}}</h4>
          <div  class="release ">发布时间：{{arrList.LastUpdateDate}}      来源：{{arrList.Subtitle}}     点击次数：{{arrList.Hits}}</div>
          <div class="title-content"><p v-html="venueList"></p></div>
      </div>
        <!-- 友情链接start -->
      <tab></tab>
      <Footer></Footer>
    </div>
</template>

<script>
import tab from '@/components/tab.vue'
    export default {
      components:{
        tab
      },
      data(){
        return{
           arrList:{},
           id:"",
           activeIndex:"",
           coolId:"",
           venueList:""
        }
      },
      mounted(){
       
        this.activeIndex = this.$route.query.activeIndex;
        this.coolId = this.$route.query.coolId;
        console.log(this.coolId,911)
        let Id= this.$route.query.id;
      
      this.$http
        .get("yxapi/api/News/GetNewsModel", { id:Id })
        .then(res => {
          this.arrList = JSON.parse(res.data.Result);
           console.log(this.arrList)
           let content = this.arrList.Description
           this.venueList = content.replace(
          /\<img src="/gi,
          '<img style="margin:0 auto" src="http://www.sxszstm.com'
        );
          console.log("shopull:0", res)
         
        });
    
      },
      methods:{

      }
        
    }
</script>

<style  scoped>
.router-active a{
color: #000000;
}
.y-advertisement {
  width: 100%;
  height: 340px;
 
}
.release{
height: 16px;
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
text-align: center;
color: #666666;
margin-top: 26px;
}
.title-content{
margin-top: 35px;
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #000000;
line-height: 36px;
margin-bottom: 60px;
}
</style>


// WEBPACK FOOTER //
// src/view/details.vue